<template>
<div class="video">
</div>
</template>

<script>
export default {
  props: [
    'ccid'
  ],
  mounted () {
    var s = document.createElement('script')
    s.src = `http://p.bokecc.com/player?vid=${this.ccid}&siteid=0575C033D2012A28&autoStart=false&width=350&playerid=8F2D63EFE045C05C&playertype=1`
    this.$el.appendChild(s)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// video.vue?80cbcd3a